import * as CONST from '../ActionTypes';

const initialState = {
  customerStatusList: [],
};

function customerStatus(state = initialState, action) {
  switch (action.type) {
    case CONST.GET_ALL_CUSTOMER_STATUS_BY_COMPANY_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          customerStatusList: action.payload,
        },
      );
    case CONST.GET_ALL_CUSTOMER_STATUS_BY_COMPANY_FAILURE:
      return Object.assign(
        {},
        state,
        {
          customerStatusList: [],
        },
      );
    default:
      return state;
  }
}

export default customerStatus;
